// Sugalarm — the kiosk keyboard and the bottom alarm banners (cycle 453.2).
//
// The kiosk WebView is TRANSLATED, never resized, when the Android keyboard
// opens (`MainActivity.applyImePan`), so the SPA is never told the keyboard's
// height, and a banner on the bottom edge of the stage can sit under it.
// Two rules, both kiosk only (operator decision 4, 2026-09-28):
//
//   1. While a text field has focus, the bottom alarm banners (the no-data
//      banner, the off-Now banner) dock at the TOP of the stage, under the
//      header — the Log overlay's approach since cycle 452.2. When the page
//      is panned a long way for a low field, the top of the stage can slide
//      off screen too; the type-floor sweep reports those routes.
//   2. When an alarm STARTS sounding while a text field has focus, the field
//      is blurred — the keyboard closes and the banner is fully visible at
//      the moment it matters. Typed text stays: blurring never clears a
//      value.
//
// Nothing here reads a field's value, a route's query string or any glucose
// value; it reads which element has focus and whether an alarm is sounding.

const TEXT_INPUT_TYPES = new Set([
  "",
  "text",
  "search",
  "email",
  "url",
  "tel",
  "password",
  "number",
]);

/** Does this element raise the on-screen keyboard when focused? */
export function isTextEntry(el: Element | null | undefined): boolean {
  if (!el) return false;
  const tag = el.tagName;
  if (tag === "TEXTAREA") {
    const t = el as HTMLTextAreaElement;
    return !t.readOnly && !t.disabled;
  }
  if (tag === "INPUT") {
    const i = el as HTMLInputElement;
    const type = (i.getAttribute("type") ?? "").toLowerCase();
    return TEXT_INPUT_TYPES.has(type) && !i.readOnly && !i.disabled;
  }
  return (el as HTMLElement).isContentEditable === true;
}

/** Rule 2's edge: an alarm has just started sounding. */
export function alarmStartedSounding(wasSounding: boolean, sounding: boolean): boolean {
  return sounding && !wasSounding;
}

/** Blur the focused field if it raises the keyboard. Returns whether it did.
 *  `blur()` leaves the field's value exactly as typed. */
export function blurFocusedTextEntry(doc: Document | null | undefined): boolean {
  const el = doc?.activeElement ?? null;
  if (!isTextEntry(el)) return false;
  (el as HTMLElement).blur();
  return true;
}
